module.exports = __webpack_public_path__ + "img/10-8.79fa17e2.png";